import Cookies from 'js-cookie';

function initUnconfiguredForSearchResults(options, $, $ajax) {
    let $toggleUnitFomFavorites;
    const config = {
        favoriteCounters: '.nShortlist',
        numberOfFavorites: parseInt($('#favoritesData').data('count'), 10),
        texts: {
            clearFavorites: $('#favoritesData').data('text-clear'),
            closeCookieNotification: $('#favoritesData').data('text-close'),
            shortlist: $('#favoritesData').data('text-shortlist'),
        },
        disableFyingIcon: false,
        onlyButtonClick: false,
        onAdd: () => {},
        onRemove: () => {},
        mapCard: false,
    };
    let currentlyActiveToggler = null;

    $.extend(config, options);

    if (options.toggleUnitFomFavoritesBtn) {
        $toggleUnitFomFavorites = $(options.toggleUnitFomFavoritesBtn);
    } else if (config.mapCard) {
        $toggleUnitFomFavorites = $('.mapFavoritesWrap > .unitsListForFacilityActions li').not('.browseList');
    } else {
        $toggleUnitFomFavorites = $('.searchFavoritesWrap > .unitsListForFacilityActions li').not('.browseList');
    }

    if (!config.onlyButtonClick) {
        initToggleListSlideEvent();
    } else {
        check($toggleUnitFomFavorites.data('unit-id')).then((data) => {
            data === true // eslint-disable-line no-unused-expressions
                ? $toggleUnitFomFavorites.addClass('active')
                : $toggleUnitFomFavorites.removeClass('active');

            toggleTitleText($toggleUnitFomFavorites);
        });
    }

    if (!config.disableFyingIcon) {
        initFlyingIconAnimation();
    }

    $toggleUnitFomFavorites.on('click', toggleFromFavorites);

    function toggleFromFavorites(event) {
        const $unitListToggler = $(event.target).parents().siblings(config.mapCard ? '.mapFavoritesToggle' : '.favoritesToggle');
        const unitId = $(event.target).data('unit-id');
        const unitName = $(event.target).data('unit-name');

        if (!$(event.target).hasClass('active')) {
            add(unitId, unitName);
            config.numberOfFavorites += 1;
        } else {
            remove(unitName);
            config.numberOfFavorites -= 1;
        }

        $(event.target).toggleClass('active');

        if (!config.onlyButtonClick) {
            toggleHasFavoriteClass($unitListToggler);
        } else {
            toggleTitleText($toggleUnitFomFavorites);
        }

        updateCounters(config.favoriteCounters, config.numberOfFavorites);
    }

    function add(unitId, unitName) {
        $ajax($('#favoritesData').data('url-add-favorites'), { unitName, unitId }).then((data) => {
            if (!data.userAuthenticated) {
                notifyUserAboutCookies(config.texts);
            }

            config.onAdd();
        });
    }

    function remove(unitName) {
        $ajax($('#favoritesData').data('url-remove-favorites'), { unitName }).then(() => {
            config.onRemove();
        });
    }

    function check(unitId) {
        return $ajax($('#favoritesData').data('url-check-favorites'), { unitId });
    }

    function toggleTitleText($btn) {
        if ($btn.hasClass('active')) {
            $btn.attr('title', $btn.data('remove-text'));
        } else {
            $btn.attr('title', $btn.data('add-text'));
        }
    }

    function initFlyingIconAnimation() {
        $('.searchFavoritesWrap > .unitsListForFacilityActions li:not(.active)').on('click', function unitsListForFacilityClick() {
            const $unitListToggler = $(this).parents().siblings('.favoritesToggle');
            const destinationIcon = $('.utilityIconNew .moveToFavourites')[0];
            flyIcon($unitListToggler, $(destinationIcon));
        });
    }

    function initToggleListSlideEvent() {
        const unitTogglerSelector = config.mapCard ? '.mapFavoritesToggle' : '.favoritesToggle';

        document.querySelectorAll(unitTogglerSelector).forEach((toggler) => {
            toggler.addEventListener('click', () => {
                slideUnitList(toggler);
            });
        });

        function slideUnitList(toggler) {
            if (!toggler.classList.contains('active')) {
                closeOtherUnitLists();
                currentlyActiveToggler = toggler;

                addClickAwayListener();
            } else {
                removeClickAwayListener();
            }

            slideList(toggler);
        }
    }

    function closeOtherUnitLists() {
        const unitTogglerSelector = config.mapCard ? '.mapFavoritesToggle' : '.favoritesToggle';

        document.querySelectorAll(`${unitTogglerSelector}.active`).forEach((toggler) => {
            slideList(toggler);
        });
    }

    function slideList(unitToggler) {
        $(unitToggler).toggleClass('active');
        $(unitToggler).siblings('.unitsListForFacilityActions').slideToggle(100);
    }

    function toggleHasFavoriteClass($listToggler) {
        const $hasFavorites = $listToggler.siblings('ul').find('li.active').length > 0;

        if ($hasFavorites) {
            $listToggler.addClass('favourit');
        } else {
            $listToggler.removeClass('favourit');
        }
    }

    function updateCounters(counters, count) {
        $('#favoritesData').data('count', count);
        $(counters).fadeOut('50', () => { $(counters).text(count).fadeIn('50'); });
    }

    function flyIcon($flyingIcon, $destinationIcon) {
        if ($flyingIcon) {
            const $flyingIconClone = $flyingIcon.clone()
                .offset({
                    top: $flyingIcon.offset().top,
                    left: $flyingIcon.offset().left,
                })
                .css({
                    opacity: '0.5',
                    position: 'absolute',
                    'z-index': '100',
                })
                .appendTo($('body'))
                .animate({
                    top: $destinationIcon.offset().top + 10,
                    left: $destinationIcon.offset().left + 10,
                }, 600, 'swing');

            $flyingIconClone.animate({ width: 0, height: 0 }, function flyingIconCloneAnimate() {
                $(this).detach();
            });
        }
    }

    function notifyUserAboutCookies(text) {
        Cookies.get('hide_favorite_message');
        if (!Cookies.get('hide_favorite_message')) {
            $('.shortlistNotification p').clone().dialog({
                autoOpen: true,
                dialogClass: 'dialogShortlist',
                closeOnEscape: true,
                buttons: [{
                    text: text.closeCookieNotification,
                    click() { $(this).dialog('close'); },
                }],
                title: text.shortlist,
                modal: false,
                draggable: false,
                resizable: false,
                minWidth: 600,
                maxWidth: 900,
            });

            Cookies.set('hide_favorite_message', true, { path: '/' });
        }
    }

    function clickAwayListener(event) {
        if (!currentlyActiveToggler.contains(event.target)) {
            slideList(currentlyActiveToggler);
            removeClickAwayListener();
        }
    }

    function addClickAwayListener() {
        document.addEventListener('click', clickAwayListener);
    }

    function removeClickAwayListener() {
        document.removeEventListener('click', clickAwayListener);
    }
}

function initClearAllFavorites() {
    const texts = {
        clearFavoritesTexts: $('#favoritesData').data('text-clear'),
        yes: $('#favoritesData').data('text-yes'),
        no: $('#favoritesData').data('text-no'),
        areYouSure: $('#favoritesData').data('text-are-you-sure'),
    };
    const removeAllUrl = $('#favoritesData').data('url-remove-all-favorites');

    $('.clearMyFavLink').on('click', (e) => {
        e.preventDefault();
        showClearAllDialog();
    });

    function showClearAllDialog() {
        const buttons = {};
        buttons[texts.no] = function textsNo() { $(this).dialog('close'); };
        buttons[texts.yes] = function textsYes() { $(this).dialog('close'); document.location.href = removeAllUrl; };

        $('#confirmWindow').html(texts.areYouSure).dialog({
            modal: true,
            title: texts.clearFavoritesTexts,
            draggable: false,
            resizable: false,
            buttons,
        });
    }
}

const initFavoritesForSearchResults = (options) => initUnconfiguredForSearchResults({ ...options }, $, $.post);
const initFavoritesForMapCard = (options) => initUnconfiguredForSearchResults({ mapCard: true, disableFyingIcon: true, ...options }, $, $.post);
const unitFavoriteToggleButton = (options) => initUnconfiguredForSearchResults({ onlyButtonClick: true, toggleUnitFomFavoritesBtn: '.favouritesBtn', ...options }, $, $.post);

export {
    initFavoritesForSearchResults,
    unitFavoriteToggleButton,
    initFavoritesForMapCard,
    initClearAllFavorites,
    initUnconfiguredForSearchResults,
};
